import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({//Estílos solamente del componente "LoginComponent"
  formContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(1),
    width: '50% !important',
    ['@media only screen and (max-width: 812px)']: {
      width: '100% !important',
    },
  },
  title: {
    fontWeight: 600,
    width: '100%',
    paddingLeft: theme.spacing(1),
  },
  titlePrincipal: {
    fontWeight: 600,
    width: '100%',
    paddingLeft: theme.spacing(1),
    // fontSize: 24,
  },
  subTitle: {
    width: '100%',
    paddingLeft: theme.spacing(1),
    // fontSize: 19,
    marginBottom: '8% !important',
    textAlign: 'justify',
  },
  margin: {
    margin: theme.spacing(1),
  },
  acceptBtn: {
    display: 'flex',
    width: '100% !important',
    justifyContent: 'center',
    // marginTop: theme.spacing(4),
    fontWeight: 'bold',
  },
  acceptContent: {
    width: '100% !important',
    textAlign: 'center !important',
  },

  cancelBtn: {
    display: 'flex',
    width: '100% !important',
    justifyContent: 'center',
    margin: theme.spacing(1),
    // marginTop: theme.spacing(1),
    fontWeight: 'bold',
  },
  topImage: {
    padding: theme.spacing(1),
  },
  captionRegister: {
    width: '100% !important',
  },
  wc100: {
    width: '100% !important',
    paddingTop: '4px !important',
    paddingLeft: '12px !important',
    paddingRight: '12px !important',
    paddingBottom: '4px !important',
  },
  pc12: {
    padding: '12px !important',
  },
  colContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  imageContent: {
    marginBottom: '8% !important',
    height: '80% !important',
    ['@media only screen and (max-width: 812px)']: {
      height: '75% !important',
      marginBottom: '8% !important',
    },
  },
  imageIcon: {
    marginTop: '3% !important',
    width: '50%',
    ['@media only screen and (max-width: 812px)']: {
      marginTop: '10% !important',
      width: '40%',
    },
  },
  containerImage: {
    display: 'grid !important',
    gridTemplateColumns: '100%',
    // height: '50vh !important',
    marginTop: 5,
    marginBottom: 5,
    // backgroundColor: theme.palette.background.paper,
    overflowY: 'none',
    ['@media only screen and (max-width: 812px)']: {
      gridTemplateColumns: '100%',
      height: '55vh !important',
    },
    // marginBottom: '5% !important'
  },

  centerContentInfoMessage: { //Help
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    // height: '34vh',
    height: '80%',
    position: 'relative',
    alignItems: 'center',
    ['@media only screen and (max-width: 812px)']: {
      width: '100%',
    }
  },
  centerContentInfoMessage1: { //Help
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    // height: '34vh',
    height: 'auto',
    position: 'relative',
    alignItems: 'center',
    ['@media only screen and (max-width: 812px)']: {
      width: '100%',
    }
  },
  imgHelp: { //Help
    height: '30vh',
    width: '50% important',
    [theme.breakpoints.only('xs')]: {
      height: '40vh',
    },
    [theme.breakpoints.only('sm')]: {
      height: '40vh',
    },
    [theme.breakpoints.only('md')]: {
      height: '44vh',
    },
    [theme.breakpoints.only('lg')]: {
      height: '48vh',
    },
    [theme.breakpoints.only('xl')]: {
      height: '50vh',
    },
  },

  textContent: {
    fontWeight: 'bold !important',
    width: '100%',
    ['@media only screen and (max-width: 812px)']: {
      width: '90%',
    }
  },
  heightContent: {
    height: '100% !important',
  },
}))
